import { render, staticRenderFns } from "./RecoveryLinkExpired.vue?vue&type=template&id=7b83ccaa&scoped=true"
var script = {}
import style0 from "./RecoveryLinkExpired.vue?vue&type=style&index=0&id=7b83ccaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83ccaa",
  null
  
)

export default component.exports